export default "__VITE_ASSET__B3ikuF6k__"